import { render, staticRenderFns } from "./QDialog.vue?vue&type=template&id=975f2ec0&scoped=true&"
import script from "./QDialog.vue?vue&type=script&lang=js&"
export * from "./QDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975f2ec0",
  null
  
)

export default component.exports